import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpDeskFormNameLabel: {
        defaultMessage: 'Team name',
        description: 'Add helpdesk name label',
        id: 'uh.help.desk.form.name.label',
    },
    helpDeskFormNamePlaceholder: {
        defaultMessage: 'e.g. HR team, Redesign Project, Team Mango',
        description: 'Add helpdesk name placeholder',
        id: 'uh.help.desk.form.name.placeholder',
    },
    helpDeskFormTitleHelperText: {
        defaultMessage: 'Who can see your team name?',
        description: 'Add helpdesk title helper text',
        id: 'uh.help.desk.form.title.helper.text',
    },
    helpDeskFormTitleHelperTooltip: {
        defaultMessage: `Your team name will be visible to anyone using Unified Help within your company. It may sometimes appear in the answers`,
        description: 'Add helpdesk title helper text tooltip',
        id: 'uh.help.desk.form.title.helper.tooltip',
    },
    helpDeskFormDescLabel: {
        defaultMessage: 'What does your team do?',
        description: 'Add helpdesk description label',
        id: 'uh.help.desk.form.description.label',
    },
    helpDeskFormDescPlaceholder: {
        defaultMessage:
            'Enter a detailed description, for example “Our team can assist with leave policies, employee benefits, workplace experience, etc.”',
        description: 'Add helpdesk description placeholder',
        id: 'uh.help.desk.form.desc.placeholder',
    },
    helpDeskFormDescHelperText: {
        defaultMessage: 'Used for improving answer quality and accuracy',
        description: 'Add helpdesk description helper text',
        id: 'uh.help.desk.form.desc.helper.text',
    },
    helpDeskFormDescHelperTooltip: {
        defaultMessage: `When enough resources aren’t available, Unified Help may use this information to give answers`,
        description: 'Add helpdesk description helper text tooltip',
        id: 'uh.help.desk.form.desc.helper.tooltip',
    },
    helpDeskFormContactInfoLabel: {
        defaultMessage: 'Preferred contact method',
        description: 'Add helpdesk contact info label',
        id: 'uh.help.desk.form.contact.info.label',
    },
    helpDeskFormContactInfoPlaceholder: {
        defaultMessage: 'Enter an email address, chat channel, or URL of a contact form',
        description: 'Add helpdesk contact info placeholder',
        id: 'uh.help.desk.form.contact.info.placeholder',
    },
    helpDeskFormNameEmptyError: {
        defaultMessage: `Enter a team name.`,
        description: 'Description message for when user entered empty team name',
        id: 'uh.help.desk.form.team.name.empty',
    },
    helpDeskFormDescriptionEmptyError: {
        defaultMessage: `Enter details of what does your team do.`,
        description: 'Description message for when user entered empty description',
        id: 'uh.help.desk.form.description.empty',
    },
    helpDeskFormContactInfoEmptyError: {
        defaultMessage: `Enter your team’s preferred contact method.`,
        description: 'Description message for when user entered empty contact information',
        id: 'uh.help.desk.form.contact.info.empty',
    },
    helpDeskFormNameLimitExceedError: {
        defaultMessage: `Enter a team name with {value} characters or less.`,
        description: 'Description message for when user enters team name more than limit characters',
        id: 'uh.help.desk.form.team.name.exceed.limit',
    },
    helpDeskFormDescriptionLimitExceedError: {
        defaultMessage: `Describe with {value} characters or less.`,
        description: 'Description message for when user enters description more than limit characters',
        id: 'uh.help.desk.form.description.exceed.limit',
    },
    helpDeskFormContactInfoLimitExceedError: {
        defaultMessage: `Enter a contact method with {value} characters or less.`,
        description: 'Description message for when user enters contact information more than limit characters',
        id: 'uh.help.desk.form.contact.information.exceed.limit',
    },
    helpDeskFormContactInfoInvalidError: {
        defaultMessage: 'We couldn’t validate your team’s contact. Make sure you enter either email address or URL.',
        description: 'Description message for when user enters invalid contact information',
        id: 'uh.help.desk.form.contact.info.invalid',
    },
    helpDeskFormCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Add helpdesk cancel button ',
        id: 'uh.help.desk.form.cancel.button',
    },
});
